import React from 'react';
import axios from 'axios';
import { withCookies } from 'react-cookie';
import { FormStyles, FormButton } from '../styles/protection.style';

/**
 * News Component
 */
class Protection extends React.Component {
  /**
   * gets cookie if there
   * @param {object} props Incoming props
   */
  constructor(props) {
    super(props);
    const { cookies } = props;
    this.state = {
      access: cookies.get('xaccess') || '',
    };
  }

  /**
   * Triggers validation
   */
  componentDidMount() {
    this.validateAuthCode({
      onMount: true,
    });
  }

  /**
   * Handles the code change for access
   * @param {string} access Access
   */
  handleCodeChange(access) {
    this.setState({
      access,
      errorMsg: '',
    });
  }

  /**
   * Validates the auth code
   * @param {props} param0 incoming props
   */
  validateAuthCode({ onMount }) {
    const { access } = this.state;
    const stateToSet = {
      initialCall: true,
    };
    axios
      .post('https://rpxug71l6h.execute-api.us-east-1.amazonaws.com/dev/authenticate', {
        accessCode: access,
      })
      .then((response) => {
        if (response && response.data && response.data.hasAccess) {
          const { cookies } = this.props;
          cookies.set('xaccess', access);
          stateToSet.grantEntry = true;
        } else if (!onMount) {
          stateToSet.errorMsg = 'Sorry, your code is invalid!';
        }
        this.setState({ ...stateToSet });
      })
      .catch(() => {
        if (!onMount) {
          stateToSet.errorMsg = 'Trouble proccess. Please try again.';
          this.setState({ ...stateToSet });
        }
      });
  }

  /**
   * Renders an auth form for the user
   * @returns {XML} Authoring form
   */
  renderAuthForm() {
    const { access, errorMsg } = this.state;
    return (
      <FormStyles>
        <div className="wrapper">
          <div>
            <div className="logo">
              <img alt="XFL Logo" src="/images/XFL_LOGO.svg" />
            </div>
            <form>
              <input
                type="text"
                access={access}
                onChange={(e) => {
                  this.handleCodeChange(e.target.value);
                }}
                placeholder="Access Code"
              />
              <FormButton
                onClick={(e) => {
                  e.preventDefault();
                  this.validateAuthCode({});
                }}
              >
                { 'Submit' }
              </FormButton>
            </form>
          </div>
          <span>
            {errorMsg}
            { '&nbsp;' }
          </span>
        </div>
      </FormStyles>
    );
  }

  /**
   * Renders an AmbientVideo Component
   * @returns {XML} AmbientVideo Component
   */
  render() {
    const { children } = this.props;
    const { grantEntry, initialCall } = this.state;

    if (grantEntry) {
      return <div>{children}</div>;
    } if (initialCall) {
      return this.renderAuthForm();
    }
    return <div />;
  }
}

export default withCookies(Protection);



// WEBPACK FOOTER //
// ./src/components/protection/components/protection.js